// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"15ff3656","980":"1e53efcd"}[chunkId] + ".chunk.js";
};